import { lazy } from 'react';
import Loadable from '../components/Loadable';
import MinimalLayout from '../layout/MinimalLayout';

const ForgotPasswordPage = Loadable(lazy(() => import('../pages/auth/ForgotPassword')));
const ResetPasswordPage  = Loadable(lazy(() => import('../pages/auth/ResetPassword')));

const AuthRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: 'forgot-password',
            element: <ForgotPasswordPage />
        },
        {
            path: 'reset-password',
            element: <ResetPasswordPage />
        }
    ]
};

export default AuthRoutes;
